import { userGroupConstants } from './userGroupConstants';
import {userConstants} from "../../../auth/_redux/authConstants";

const makeInitialState = () => ({
  requestActive: false,
  requestSaveActive: false,
  shouldReload: true,
  items: [],
  rowsPerPage: 10,
  page: 1,
  sortBy: "id",
  sortDirection: "desc",
  total: 0,
  error: '',
  query: "",
  inProgress: true,
});

export function acl_user_groups(state = makeInitialState(), action) {
  switch (action.type) {
    case userConstants.LOGOUT:
      return makeInitialState();
    case userGroupConstants.ACL_USER_GROUP_LIST_REQUEST:
      return {
        ...state,
        requestActive: true,
        shouldReload: false,
        error: '',
        total: 0,
        inProgress: true,
      };
    case userGroupConstants.ACL_USER_GROUP_LIST_SUCCESS:
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        items: action.user_groups.rows ? action.user_groups.rows : [],
        total: action.user_groups.total ? action.user_groups.total : 0,
        inProgress: false,
      };
    case userGroupConstants.ACL_USER_GROUP_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        inProgress: false,
      };
    case userGroupConstants.ACL_USER_GROUP_LIST_CHANGED:
      return {
        ...state,
        shouldReload: true,
      };
    case userGroupConstants.ACL_USER_GROUP_LIST_PAGINATION: {
      let shouldReload = state.items.length === 0 ? true : false;

      if (state.rowsPerPage !== action.pagination.rowsPerPage
        || state.page !== action.pagination.page
        || state.sortBy !== action.pagination.sortBy
        || state.sortDirection !== action.pagination.sortDirection
        || state.query !== action.pagination.query
        || state.shouldReload) {
        shouldReload = true;
      }

      return {
        ...state,
        rowsPerPage: action.pagination.rowsPerPage,
        page: action.pagination.page,
        sortBy: action.pagination.sortBy,
        sortDirection: action.pagination.sortDirection,
        query: action.pagination.query,
        shouldReload
      };
    }

    case userGroupConstants.ACL_USER_GROUP_SAVE_REQUEST:
      return {
        ...state,
        requestSaveActive: true,
      }
    case userGroupConstants.ACL_USER_GROUP_SAVE_SUCCESS:
      if (action.isNew) {
        return {
          ...state,
          requestSaveActive: false,
          items: [...state.items, action.user_group],
        }
      }
      return {
        ...state,
        requestSaveActive: false,
        items: state.items.map(t => t.id === action.user_group.id ? action.user_group : t)
      }
    case userGroupConstants.ACL_USER_GROUP_SAVE_FAILURE:
      return {
        ...state,
        requestSaveActive: false,
        error: action.error,
      }

    default:
      return state
  }
}
